import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { preloadServiceRequestsList } from '@/ui/pages/ServiceRequests/serviceRequestsLazy';
import { serviceRequestsScreen } from '@/ui/pages/ServiceRequests/serviceRequestsScreen';

/**
 * HS-1548: the admin Requests list, a `@smartsash/data-screen` definition like the other lists.
 * The screen is bound to a local identifier because `autoCodeSplitting` accepts no member
 * expression as `component` (see `groups.index.tsx`). The loader also starts the list's lazy
 * row actions (R2-4) the list request.
 */
const ServiceRequestsListScreen = serviceRequestsScreen.ListScreen;
const loadList = serviceRequestsScreen.loaderFor();

export const Route = createFileRoute('/_dashboard/requests/')({
  validateSearch: serviceRequestsScreen.validateSearch,
  loaderDeps: serviceRequestsScreen.loaderDeps,
  beforeLoad: requireRoute('/requests'),
  loader: (context) => {
    preloadServiceRequestsList();
    return loadList(context);
  },
  component: ServiceRequestsListScreen,
});
